import { useDispatch, useSelector } from "react-redux";
import ObjectSelectionConfirmationBox from "../general/ObjectSelectionConfirmationBox";
import {
  setIsSelectRoofOpen,
  setPVDesignRequestBoxOpen,
  setSelectedRoofs,
} from "../../redux/pvDesign";

const PVRooftopPolygonsSelectionConfirmationBox = () => {
  const { selectedRoofs, isSelectRoofsOpen } = useSelector(
    (state) => state.pvDesign
  );

  const dispatch = useDispatch();

  const goToForm = () => {
    dispatch(setPVDesignRequestBoxOpen(true));
    dispatch(setIsSelectRoofOpen(false));
  };

  const onConfirm = () => {
    goToForm();
  };

  const onCancel = () => {
    dispatch(setSelectedRoofs([]));
    goToForm();
  };

  if (!isSelectRoofsOpen) return null;

  return (
    <ObjectSelectionConfirmationBox
      selectedObjects={selectedRoofs}
      onConfirm={onConfirm}
      onCancel={onCancel}
      title="Roof Selection"
    />
  );
};

export default PVRooftopPolygonsSelectionConfirmationBox;
